import 'nodelist-foreach'
import webkitLineClamp from 'webkit-line-clamp'

export default ({
  selector = '[data-clamp]',
  getClampingValue = el => el.getAttribute('data-clamp') || 2
} = {}) => {
  const elements = document.querySelectorAll(selector)
  if (!elements || !elements.length) return

  elements.forEach(element => {
    const lineLength = getClampingValue(element)
    if (lineLength === false || lineLength === undefined) return
    webkitLineClamp(element, lineLength)
  })

  return {
    destroy: undefined
  }
}
